var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35 18.9C3.99 18.9 3.675 18.765 3.405 18.495C3.135 18.225 3 17.91 3 17.55V5.85C3 5.49 3.135 5.175 3.405 4.905C3.675 4.635 3.99 4.5 4.35 4.5H19.65C20.01 4.5 20.325 4.635 20.595 4.905C20.865 5.175 21 5.49 21 5.85V17.55C21 17.91 20.865 18.225 20.595 18.495C20.325 18.765 20.01 18.9 19.65 18.9H4.35ZM12 12.105L4.35 7.0875V17.55H19.65V7.0875L12 12.105ZM12 10.755L19.56 5.85H4.4625L12 10.755ZM4.35 7.0875V5.85V17.55V7.0875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.5991f8fd1f97f60838db87ee585f2030.svg";
export { ForwardRef as ReactComponent };